import { Dialog, DialogContent } from '@mui/material';
import { AppDialogTitle, AppInput, DialogButtons } from 'components/common';
import { t } from 'i18next';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { TKeys } from 'utils/enums';
import { getMessageText } from 'utils/helpers';
import { contractCodeSchema } from './login.schema';
import { yupResolver } from '@hookform/resolvers/yup';

type Props = DialogProps<string>;

const ManagementCode: FC<Props> = (props: Props) => {
    const { open, onClose, onSubmit } = props;
    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors },
    } = useForm<ManagementContractCode>({
        resolver: yupResolver(contractCodeSchema(t)),
        defaultValues: {
            contract_code: '',
        },
        shouldUnregister: true,
    });
    const handleFormSubmit = async (data: ManagementContractCode) => {
        onSubmit && onSubmit(data.contract_code);
        onClose();
    };

    return (
        <Dialog
            disableEscapeKeyDown
            open={open}
            onClose={(_, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            maxWidth="sm"
            fullWidth>
            <AppDialogTitle title={t(TKeys.LBL010006)} />
            <form onSubmit={handleSubmit(handleFormSubmit)} noValidate>
                <DialogContent>
                    <AppInput
                        register={register}
                        name={'contract_code'}
                        setValue={setValue}
                        error={!!errors.contract_code}
                        helperText={errors.contract_code?.message}
                        required
                        label={t(TKeys.LBL010005)}
                        placeHolder={getMessageText(t(TKeys.MSE00001), t(TKeys.LBL010005))}
                    />
                </DialogContent>
                <DialogButtons
                    onClose={() => onClose()}
                    cancelLabel={t(TKeys.BTN000016)}
                    submitLabel={t(TKeys.BTN000017)}
                />
            </form>
        </Dialog>
    );
};

export default ManagementCode;
